import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('currency', val => numeral(val).format('0,0'))

Vue.filter('currency2', val => numeral(val).format('0,0.00'))
